import { Select } from "../Select";

import type { SxProps, Theme } from "@mui/material";

interface Props {
  onChange: (value: string) => void;
  defaultValue?: string;
  value?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export function CurrencySelect(props: Props) {
  const { onChange, defaultValue = "", value, disabled = false, sx } = props;
  return (
    <Select
      inputLabel="Currency"
      disabled={disabled}
      defaultValue={defaultValue ?? ""}
      value={value}
      onChange={onChange}
      options={[
        {
          value: "CAD",
          label: "CAD",
        },
        {
          value: "USD",
          label: "USD",
        },
      ]}
      sx={sx}
      selectProps={{ autoWidth: false }}
    />
  );
}
